import { Capacitor, SystemBars, SystemBarsStyle } from '@capacitor/core';
import { StatusBar, Style } from '@capacitor/status-bar';
import { App } from '@capacitor/app';

/** Solid status bar background (avoid transparent / white flash when WebView focus changes). Adjust to match your brand. */
const STATUS_BAR_BACKGROUND = '#1a1a1a';

export async function initStatusBar() {
    if (!Capacitor.isNativePlatform()) {
        return;
    }

    const platform = Capacitor.getPlatform();

    try {
        if (platform === 'ios') {
            await StatusBar.setOverlaysWebView({ overlay: false });
            await StatusBar.setStyle({ style: Style.Dark });
            await StatusBar.setBackgroundColor({ color: STATUS_BAR_BACKGROUND });
        } else if (platform === 'android') {
            try {
                await SystemBars.setStyle({ style: SystemBarsStyle.Dark });
            } catch (e) {
                await StatusBar.setStyle({ style: Style.Dark });
                await StatusBar.setBackgroundColor({ color: STATUS_BAR_BACKGROUND });
            }
        }
    } catch (e) {
        console.warn('initStatusBar', e);
    }
}

/**
 * Call after Capacitor InAppBrowser closes. On iOS, StatusBar reapplies config on viewDidAppear but
 * setOverlaysWebView is a no-op when the value is unchanged, so resizeWebView() never runs and the
 * WKWebView frame can stay wrong. Toggling overlay forces a layout pass, then we restore style/background.
 */
export async function refreshStatusBarAfterInAppBrowser() {
    if (!Capacitor.isNativePlatform()) {
        return;
    }

    const platform = Capacitor.getPlatform();

    try {
        if (platform === 'ios') {
            await StatusBar.setOverlaysWebView({ overlay: true });
            await StatusBar.setOverlaysWebView({ overlay: false });
            await StatusBar.setStyle({ style: Style.Dark });
            await StatusBar.setBackgroundColor({ color: STATUS_BAR_BACKGROUND });
        } else {
            await initStatusBar();
        }
    } catch (e) {
        console.warn('refreshStatusBarAfterInAppBrowser', e);
    }
}

/**
 * Apply on load and when the app resumes (e.g. after Moneris / iframe focus changes system UI).
 */
export function setupStatusBar() {
    if (!Capacitor.isNativePlatform()) {
        return;
    }

    initStatusBar();

    App.addListener('resume', () => {
        initStatusBar();
    });
}
